import { customInstances } from '../default-setup';

export function getCredsInfo() {
    return customInstances.get(`oauth/credentials/ `);
}

export function tryAuth(type) {
    return customInstances.get(`oauth/consent/?provider=google&type=${type}`);
}
